/**
 * @module app.core
 */

import { FrameworkConfiguration } from 'aurelia-framework';
import { CoreModule } from './module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(CoreModule.registrationKey, CoreModule)
        .feature('app/core/components/custom-fields');  // Loads custom-fields resources as a feature

    config.globalResources([ // Load any other resources here
        // elements
        './elements/ess-tenant-selection-modal',

        // value converters
        './value-converters/name-converters',
        './value-converters/stamp-converters',

        //formatters
        './elements/addresses/format-address-inline.html',
        './elements/addresses/format-address.html',
        './elements/phone-numbers/format-phone-numbers.html'
    ]);
}
